class NumberFormatter {
  /**
   * Returns the rounded value of n to specified precision
   * @param {*} n
   * @param {*} precision
   */
  round (n, precision=2) {
    precision = Math.abs(precision)
    return +(Math.round(Number.parseFloat(n) + `e+${precision}`)  + `e-${precision}`)
  }

  /**
   * Transforms a float to localized numeric string (0.12 => 0,12)
   * @param {*} n
   */
  localize (n) {
    return n.toString().replace('.', ',')
  }

  /**
   * Parse a localized numeric string to float (0,12 => 0.12)
   * @param {*} n
   */
  parse (n) {
    return Number.parseFloat(this.softParse(n))
  }

  /**
   * Parse a localized numeric without removing invalid characters e.g. ,
   */
  softParse (n) {
    return n.toString().replace(',', '.')
  }
}

export default new NumberFormatter()
